import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
/* Providers */
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomTranslateLoader } from './shared/utils/custom-translate-loader.component';
import { environment } from '../environments/environment';
import { ConfigLoaderService } from './shared/services/config-loader.service';
import { PluginsModule } from './shared/plugins.module';
import { RouterService } from './shared/services/router.service';
import { APP_PROVIDERS } from './app.providers';
import { CoreConfigurationsLoaderService, CoreConfigurationsLoaderModule } from '@vfde-fe/ngx-lib/services/core-configurations-loader';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { CoreAuthenticationService } from '@vfde-fe/ngx-lib/services/core-authentication';
import { CustomErrorHandlerService } from '@vfde-fe/ngx-lib/services/custom-error-handler';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { HTTPClientInterceptor } from './shared/services/interceptors/http-client-interceptor';
import { TrackingModule } from '@vfde-fe/ngx-lib/plugins/tracking';
import {APP_BASE_HREF} from '@angular/common';

// eslint-disable-next-line
export function createTranslateLoader (
  http: HttpClient,
  configLoaderService: ConfigLoaderService,
) {
  // eslint-disable-next-line
  return new CustomTranslateLoader(
    http,
    configLoaderService,
    environment.configPath + 'i18n/',
    '.json',
  );
}
// eslint-disable-next-line
export function configLoaderFactory (config: ConfigLoaderService) {
  return () => config.load();
}
/** AppModule */
@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreConfigurationsLoaderModule.forRoot({
      provide: CoreConfigurationsLoaderService,
      useClass: ConfigLoaderService,
    }),
    PluginsModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    TrackingModule,
    NgxPageScrollCoreModule,
    SharedModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, CoreConfigurationsLoaderService],
      },
    }),
  ],
  providers: [
    ConfigLoaderService,
    APP_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: configLoaderFactory,
      deps: [CoreConfigurationsLoaderService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HTTPClientInterceptor,
      multi: true,
      deps: [
        RouterService,
        RoutesUtilsService,
        CustomErrorHandlerService,
        SpinnerService,
        CoreAuthenticationService,
      ],
    },
    { provide: APP_BASE_HREF, useValue: '/hilfe/formulare' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
